<template>
  <div id="DmhMessage">
    <div
      v-if="selectedView === 'landing'"
      class="dmh-f2f-container animate__animated animate__fadeIn"
    >
      <h2 class="dmh-start-title brand-text mb-5">Messaging</h2>
      <div class="d-flex flex-column align-items-center">
        <p v-if="textContent">{{ textContent }}</p>
        <div class="dmh-confirm-container w-100 shadow mb-5">
          <textarea
            v-model="messageText"
            placeholder="Send a message"
            class="dmh-confirm-input"
            rows="4"
            maxlength="300"
          />
        </div>
        <b-button
          variant="cta-outline"
          size="lg"
          @click="handleClick"
          :disabled="messageText.length === 0"
          squared
          ><span v-if="!isSendMessageLoading && !bookingCancelLoading">{{
            buttonText
          }}</span>
          <b-spinner v-else></b-spinner>
        </b-button>
      </div>
    </div>
    <div
      v-else-if="selectedView === 'success'"
      class="dmh-f2f-container animate__animated animate__fadeIn"
    >
      <h2 class="dmh-start-title brand-text mb-5">Success!</h2>
      <div class="d-flex flex-column align-items-center">
        <p class="pb-5">You have sucessfully sent the message.</p>
        <b-button variant="cta" size="lg" squared @click="$router.push('/')"
          >Back to home</b-button
        >
      </div>
    </div>
    <div
      v-else-if="selectedView === 'error'"
      class="dmh-f2f-container animate__animated animate__fadeIn"
    >
      <h2 class="dmh-start-title brand-text mb-5">Something went wrong</h2>
      <b-button variant="cta" size="lg" squared @click="$router.push('/')"
        >Back to home</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import EventBus from "@/helpers/eventbus";
import { mapGetters } from "vuex";

export default {
  name: "F2F",
  components: {},
  data() {
    return {
      selectedView: "landing",
      messageText: "",
      isSendMessageLoading: false,
      bookingCancelLoading: false,
      acceptedParams: ["reject", "reply", "cancel"]
    };
  },
  mounted() {
    if (!this.acceptedParams.includes(this.$route.params.type)) {
      this.$router.push("/");
    } else {
      EventBus.$emit("updateNav", "message");
    }
  },
  methods: {
    handleClick() {
      if (this.$route.params.type === "cancel") {
        this.cancelBooking();
      } else {
        this.sendMessage();
      }
    },
    async sendMessage() {
      if (this.isSendMessageLoading) {
        return;
      }
      this.isSendMessageLoading = true;
      const payload = {
        user_id: this.$store.getters.user_id,
        session_id: this.$route.params.sessionId,
        message: this.messageText
      };
      const res = await axios.post(
        config.api_env + "/application/api/u/dmh/send-response",
        payload,
        config.options
      );
      this.isSendMessageLoading = false;
      if (res.data.success) {
        this.selectedView = "success";
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } else {
        this.selectedView = "error";
      }
    },
    async cancelBooking() {
      if (this.bookingCancelLoading) {
        return;
      }
      this.bookingCancelLoading = true;
      const payload = {
        user_id: this.$store.getters.user_id,
        appointment_id: this.$route.params.sessionId,
        appointment_type: "f2f",
        message: this.messageText
      };
      const res = await axios.post(
        config.api_env + "/application/api/u/dmh/cancel-appointment",
        payload,
        config.options
      );
      this.bookingCancelLoading = false;
      if (res.data.success) {
        this.selectedView = "success";
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } else {
        this.selectedView = "error";
      }
    }
  },
  computed: {
    ...mapGetters(["user"]),
    textContent() {
      return this.$route.params.type === "reject"
        ? `You have rejected the options provided. Please message us to let us know why none of these options were suitible.`
        : this.$route.params.type === "reply"
        ? "Please send a response to the clinician's message below."
        : this.$route.params.type === "cancel"
        ? "You are cancelling the session. Please message us to let us know why you need to cancel."
        : null;
    },
    buttonText() {
      return this.$route.params.type === "cancel"
        ? "Cancel Session"
        : "Send Message";
    }
  }
};
</script>
<style lang="less">
#DmhMessage {
  padding: 70px 0;
  min-height: 85vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  .map-container {
    border-radius: 16px;
  }

  b {
    font-family: "PlusJakartaSansBold";
  }

  p {
    font-size: 1.6rem;
    text-align: center;
    max-width: 400px;
  }

  .dmh-f2f-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;

    .prompt-container {
      margin-top: 20px;
      padding: 25px;
      max-width: 650px;
      border: 2px solid #e0e5f5;
      border-radius: 16px;
      background-color: white;

      p {
        font-size: 1.6rem;
        text-align: center;
        padding: 20px;
      }
    }

    .dmh-start-title {
      text-align: center;
      font-size: 3.8rem;
      letter-spacing: 0;
      font-family: "PlusJakartaSansBold";
    }

    .dmh-prompt-title {
      padding: 0;
      margin-top: 0;
      margin-bottom: 30px;
      text-align: center;
      font-size: 2.4rem;
      letter-spacing: 0;

      font-family: "PlusJakartaSansBold";
    }

    .phone-item {
      font-size: 1.8rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "PlusJakartaSansRegular";

      .phone-link {
        border-bottom: 1.5px solid;
        font-family: "PlusJakartaSansBold";
      }
    }

    .dmh-options-container {
      margin: 20px;
      max-width: 650px;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      width: 100%;
    }

    .dmh-confirm-container {
      display: flex;
      flex-direction: column;
      font-size: 1.6rem;
      background: #dedede;
      border-radius: 8px;
      padding: 15px;
      margin-bottom: 20px;

      .dmh-confirm-input {
        font-family: "PlusJakartaSansRegular";
        font-size: 2rem;
      }

      textarea {
        background: #dedede;
        border: none;
        width: 100%;
      }

      textarea:focus {
        outline-width: 0;
      }
    }

    .clinician-image {
      max-width: 80px;
      border-radius: 1000px;
      border: 4px solid inherit;
    }
  }

  .fa-times-circle.brand-primary {
    color: #ff4040 !important;
  }
}
</style>
